import * as ResultsProcessStatementTable from './ResultsProcessStatementTable';
import * as ResultsTable from './ResultsTable';


export const SearchBarTableConfig = {
  ResultsProcessStatementTable,
  ResultsTable,

};
